// src/components/onboarding/screens/SpecialitesScreen.js
import React from 'react';
import OnboardingLayout from '../OnboardingLayout';
import { CheckboxItem, ScreenTitle } from '../OnboardingUI';
import { specialitesOptions, TOTAL_STEPS } from '../onboardingData';

const SpecialitesScreen = ({
  specialites,
  mathsOption,
  classe,
  onChange,
  onNext,
  loading,
  error
}) => {
  const maxSpecialites = classe === 'premiere' ? 3 : 2;
  const hasMathsSpecialite = specialites.includes('Maths');

  const toggleSpecialite = (value) => {
    if (specialites.includes(value)) {
      const newSpecialites = specialites.filter(v => v !== value);
      // Si on retire Maths, on retire aussi l'option maths
      if (value === 'Maths') {
        onChange({ specialites: newSpecialites, mathsOption: '' });
      } else {
        onChange({ specialites: newSpecialites });
      }
    } else if (specialites.length < maxSpecialites) {
      onChange({ specialites: [...specialites, value] });
    }
  };

  const toggleMathsOption = (option) => {
    onChange({ mathsOption: mathsOption === option ? '' : option });
  };

  const canProceed = specialites.length === maxSpecialites;

  return (
    <OnboardingLayout
      currentStep={2.5}
      totalSteps={TOTAL_STEPS}
      canProceed={canProceed}
      onNext={onNext}
      loading={loading}
      error={error}
    >
      <ScreenTitle
        title="Quelles spécialités tu as cette année ?"
        subtitle={
          <span>
            Clique sur tes {maxSpecialites} spés
            <span className="ml-2 px-2 py-0.5 bg-emerald-500/20 text-emerald-400 rounded-full text-sm">
              {specialites.length} / {maxSpecialites}
            </span>
          </span>
        }
      />

      <div className="flex-1 overflow-y-auto mb-4 pr-1">
        {specialitesOptions.map(option => {
          const isChecked = specialites.includes(option);
          const isDisabled = !isChecked && specialites.length >= maxSpecialites;
          return (
            <CheckboxItem
              key={option}
              checked={isChecked}
              label={option}
              onClick={() => toggleSpecialite(option)}
              disabled={loading || isDisabled}
            />
          );
        })}

        {/* Option Maths complémentaires/expertes en Terminale */}
        {classe === 'terminale' && (
          <>
            <div className="h-px bg-gray-700 my-3" />
            {hasMathsSpecialite ? (
              <CheckboxItem
                checked={mathsOption === 'expertes'}
                label="+ Maths expertes"
                emoji="➕"
                onClick={() => toggleMathsOption('expertes')}
                disabled={loading}
              />
            ) : (
              <CheckboxItem
                checked={mathsOption === 'complementaires'}
                label="+ Maths complémentaires"
                emoji="➕"
                onClick={() => toggleMathsOption('complementaires')}
                disabled={loading}
              />
            )}
          </>
        )}
      </div>
    </OnboardingLayout>
  );
};

export default SpecialitesScreen;
